import { Suspense } from 'react';
import { BrowserRouter, useRoutes } from 'react-router';

import { FullPageLoader } from '@/shared/components/FullPageLoader';

import { routes } from './routes';

function Routes() {
  return useRoutes(routes);
}

/**
 * Declarative mode, but with routes as plain data. Moving to
 * `createBrowserRouter` later is a change to this file alone.
 */
export function Router() {
  return (
    <BrowserRouter>
      <Suspense fallback={<FullPageLoader />}>
        <Routes />
      </Suspense>
    </BrowserRouter>
  );
}
